<template>
  <div class="box13">
    <pageTitle
      title="课程怎么样&nbsp;&nbsp;还得看学生评价"
      text="十多年积淀的教学口碑，靠得就是过硬的教学实力与满意的学习效果"
      titleColor="#24375C"
      titColor="#86909C"
    />
    <studentEvaluation
      :evaluateData="evaluateData"
      :styleData="styleData"
      @provideIndex="provideIndex"
      scrollColor="rgba(75,132,250,0.16)"
      blockColor="#4b84fa"
    />
    <previewImage
      ref="previewImage"
      :clickedIndex="clickedIndex"
      :isPreview="isPreview"
      type="img"
      :targetImg="evaluateData[this.cur].imgUrlList[this.clickedIndex].img"
      @close="close"
    />
    <p class="tip">
      * 资料来源：博学谷软件测试学科班主任老师与同学们的日常沟通截图
    </p>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import previewImage from "../common/previewImage.vue";
import studentEvaluation from "../common/student-evaluation.vue";
export default {
  components: {
    pageTitle,
    studentEvaluation,
    previewImage,
  },

  data() {
    return {
      clickedIndex: 0,
      isPreview: false,
      cur: 0,
      evaluateData: [
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/softwareTest/box13/7.png"),
              id: 1,
            },
            {
              img: require("../../../assets/coursePage/softwareTest/box13/8.png"),
              id: 2,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/softwareTest/box13/5.png"),
              id: 3,
            },
            {
              img: require("../../../assets/coursePage/softwareTest/box13/6.png"),
              id: 4,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/softwareTest/box13/3.png"),
              id: 5,
            },
            {
              img: require("../../../assets/coursePage/softwareTest/box13/4.png"),
              id: 6,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/softwareTest/box13/1.png"),
              id: 7,
            },
            {
              img: require("../../../assets/coursePage/softwareTest/box13/2.png"),
              id: 8,
            },
          ],
        },
      ],

      titleColor: "#3E4F48",

      styleData: {
        imgBorder: "border: 0.053333rem solid #bedaff;",
        imgHoverBorder: "border: 0.053333remsolid #4080ff;",
      },
    };
  },
  methods: {
    provideIndex(index, index1) {
      this.clickedIndex = index1;
      this.cur = index;
      this.isPreview = true;
    },
    close() {
      this.isPreview = false;
      this.clickedIndex = 0;
      this.cur = 0;
      // this.imageUrl = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.box13 {
  padding: 80px 0 88px;
  width: 100%;
  background: url("../../../assets/coursePage/java/box10/bgc.png") no-repeat;
  background-size: cover;
  .tip {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #b9c8d9;
    line-height: 20px;
    text-align: center;
    margin-top: 62px;
  }
}
</style>
